import { render, staticRenderFns } from "./edit-name.vue?vue&type=template&id=478b36b6&scoped=true&"
import script from "./edit-name.vue?vue&type=script&lang=js&"
export * from "./edit-name.vue?vue&type=script&lang=js&"
import style0 from "./edit-name.vue?vue&type=style&index=0&id=478b36b6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478b36b6",
  null
  
)

export default component.exports